<template>
  <div class="board-container" ref="boardContainer">
    <div class="board-container-header">
    <header class="header-title">
      <i class="iconfont icon-back" @click="handleBack"></i>
      <h4>汇报看板</h4>
    </header>
    <div class="company-selection" @click="selectCompanyHandler">
      <span>{{ seletionData.company }}</span>
      <i class="iconfont icon-xiangxiajiantou company-arrow"></i>
    </div>
    <div class="tab-area">
      <ul class="tab-list">
        <li
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="item.id"
          :style="{ width: `${100 / tabList.length}%` }"
          :class="{ 'active-tab': activeTab === index }"
          @click="tabClickHandle(index)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <div class="date-selection-warpper">
      <div class="date-selection">
        <div class="flex-warpper" @click="selectDateTypeHandler" v-show="activeTab === 0">
          <span>{{ seletionDailyData.dateType }}</span>
          <i class="iconfont icon-xiangxiajiantou"></i>
        </div>
        <div class="flex-warpper" @click="selectDailyDateHandler" v-if="activeTab === 0">
          <span>{{ seletionDailyData.selectedDate }}</span>
          <i class="iconfont icon-xiangxiajiantou"></i>
        </div>
        <div class="flex-warpper" @click="selectDateHandler" v-if="activeTab === 1">
          <span>{{ seletionData.selectedDate }}</span>
          <i class="iconfont icon-xiangxiajiantou"></i>
        </div>
      </div>
      <div class="date-show">
        <span>数据截止时间：</span>
        <span class="vei-bas">{{ seletionData.deadlineDate }}</span>
      </div>
    </div>
    </div>
    <div class="chart-list">
      <ul class="board-list-cards">
        <li v-for="(card, index) in boardList" :key="card.id" class="board-cards-item">
          <template v-if="card.isShow">
            <div class="card-title-warpper">
              <span class="card-title">{{ card.title }}</span>
              <span class="card-detail" @click="toMore(card.id)">更多</span>
            </div>
            <div v-if="index === 0">
              <div v-if="activeTab === 0" class="background-block-warpper">
                <div class="background-block">
                  <div class="after-submited-block" :style="handleAfterSubmitedBlock()"></div>
                  <div class="submited-block" :style="handleSubmitedBlock()"></div>
                </div>
                <div style="line-height: 30px">{{ dailyOverview.submitRate }}</div>
              </div>
              <div class="strip-block-warpper" v-else>
                <div class="strip-block">
                  <div class="yellow-block" :style="{ width: yellowBlockWidth }"></div>
                  <div class="num-block">{{ overview.personNum }}</div>
                </div>
                <div class="strip-block">
                  <div class="blue-block" :style="{ width: overview.approvalNum === 0 ? 0 : '80%' }"></div>
                  <div class="num-block">{{ overview.approvalNum }}</div>
                </div>
              </div>
              <div class="total-statistics-warpper">
                <div class="total-statistics">
                  <div>
                    <span v-show="activeTab === 0" class="tip-block bgc-b"></span>
                    <span>{{ `${activeTab === 0 ? "已提交人次：" : "提交人数："}` }}</span>
                    <span v-if="activeTab === 0">{{ dailyOverview.submittedTotalNum }}</span>
                    <span v-else>{{ overview.personNum }}</span>
                  </div>
                  <div>
                    <span v-show="activeTab === 0" class="tip-block bgc-c"></span>
                    <span>{{ `${activeTab === 0 ? "应提交人次：" : "汇报数量："}` }}</span>
                    <span v-if="activeTab === 0">{{ dailyOverview.shouldSubmitTotalNum }}</span>
                    <span v-else>{{ overview.approvalNum }}</span>
                  </div>
                </div>
                <div v-if="activeTab === 0" class="after-submit">
                  <span v-show="activeTab === 0" class="tip-block bgc-o"></span>
                  <span>补交人次：</span>
                  <span v-if="activeTab === 0">{{ dailyOverview.supplementTotalNum }}</span>
                  <span v-else>{{ overview.personNum }}</span>
                </div>
              </div>
            </div>
            <template v-else>
              <div :id="`canvas-card-${index}`" class="canvas-card"></div>
            </template>
          </template>
        </li>
      </ul>
    </div>
    <van-action-sheet v-model="showDatePicker">
      <van-datetime-picker 
        v-model="selectedDate" 
        type="year-month" 
        title="选择年月" 
        :formatter="formatter" 
        @confirm="dateConfirm" 
        @cancel="showDatePicker = false" />
    </van-action-sheet>
    <van-action-sheet v-model="showDailyDatePicker">
      <van-datetime-picker
        v-model="selectedDailyDate"
        :type="seletionDailyData.dateType === '天' ? 'date' : 'year-month'"
        title="选择年月日"
        :formatter="formatter"
        @confirm="dateDailyConfirm"
        @cancel="showDailyDatePicker = false"
      />
    </van-action-sheet>
    <van-popup position="bottom" round v-model="showDateType">
      <van-picker show-toolbar v-model="seletionDailyData.dateType" :columns="dateTypeOptions" @confirm="onDateTypeConfirm" @cancel="showDateType = false" />
    </van-popup>
  </div>
</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";
import {
  getPersonalReportBoard,
  getPersonaldistribution,
  getApproveTrend,
  getPersonalReport,
  getOrganizationReport,
  getCompanyPersonReport,
  getOverviewData,
  getReportStatisticsTrend,
  getReportStatisticsSubmitNum,
  getReportStatisticsSubmitRate,
  getCompanySystem,
} from "@/axios/services";
import { Toast } from "vant";
import { mapState } from "vuex";
import VeiBanBridge from "@/utils/bridge";

export default {
  data() {
    return {
      showDatePicker: false,
      showDateType: false,
      showDailyDatePicker: false,
      seletionData: {
        company: "",
        selectedDate: new Date().getDate() === 1 ? this.getDate("yyyy-MM", "yesterday") : this.getDate("yyyy-MM"),
        deadlineDate: this.getDate("yyyy-MM-dd", "yesterday"),
        dateType: "天",
      },
      dateTypeFormat: "date",
      selectedDate: new Date().getDate() === 1 ? new Date() - 1000 * 60 * 60 : new Date(),
      selectedDailyDate: "",
      seletionDailyData: {
        dateType: "天",
        selectedDate: this.getDate("yyyy-MM-dd", "yesterday"),
      },
      tabList: [
        { id: 0, label: "日报" },
        { id: 1, label: "汇报管理" },
      ],
      dateTypeOptions: ["天", "月"],
      activeTab: 0,
      overview: {
        personNum: 0,
        approvalNum: 0,
      },
      companyId: "",
      companyInfo: {
        scopeType: 0,
        companyId: "",
        officeId: "",
      },
      dailyParams: {
        companyId: "",
        officeId: "",
        reportYear: "",
        reportMonth: "",
        reportDate: "",
      },
      dailyOverview: {
        shouldSubmitTotalNum: 0,
        submitRate: "0%",
        submittedTotalNum: 0,
        supplementTotalNum: 0,
      },
      boardList: [
        {
          id: 0,
          type: "strip",
          title: "总览",
          isShow: true,
        },
        {
          id: 1,
          type: "pie",
          title: "汇报流程分布",
          echartsOptions: {
            tooltip: {
              trigger: "item",
            },
            legend: {
              bottom: "10",
              left: "center",
            },
            series: [
              {
                name: "汇报流程分布",
                type: "pie",
                center: ["50%", "40%"],
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: "#fff",
                  borderWidth: 2,
                },
                label: {
                  show: true,
                  position: "inner",
                  formatter: "{d}%",
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: "20",
                    fontWeight: "bold",
                  },
                },
                labelLine: {
                  show: false,
                },
                data: [],
              },
            ],
          },
          options: {},
          isShow: true,
        },
        {
          id: 2,
          type: "barAndLine",
          title: "趋势",
          echartsOptions: {
            grid: {
              top: 28,
            },
            legend: {
              show: true,
              bottom: "10",
              left: "center",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                interval: 0,
                rotate: 40,
                fontSize: 10,
                color: "#999",
                formatter: (val) => {
                  return val.slice(0, 8);
                },
              },
            },
            yAxis: {
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  type: "dashed",
                },
              },
            },
            series: [
              {
                name: "汇报数量",
                data: [],
                type: "bar",
                itemStyle: {
                  color: "#1584ff",
                },
                barWidth: "60%",
                label: {
                  show: true,
                  position: "top",
                  fontSize: 16,
                  fontWeight: "bold",
                },
                // yAxisIndex: 0,
              },
              {
                name: "提交人数",
                type: "line",
                data: [],
                itemStyle: {
                  color: "#ffba19",
                },
                symbolSize: 8,
                lineStyle: {
                  width: 4,
                },
                label: {
                  // formatter: "{c}%",
                  show: true,
                  position: "top",
                  fontSize: 12,
                  fontWeight: "bold",
                },
                //  yAxisIndex: 1,
              },
            ],
          },
          options: {},
          isShow: true,
        },
        {
          id: 3,
          type: "bar",
          title: "个人汇报排名",
          echartsOptions: {
            grid: {
              top: 28,
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                interval: 0,
                rotate: 40,
                fontSize: 10,
                color: "#999",
                formatter: (val) => {
                  return val.slice(0, 8);
                },
              },
            },
            yAxis: {
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  type: "dashed",
                },
              },
            },
            series: [
              {
                data: [],
                type: "bar",
                itemStyle: {
                  color: "#00ca7b",
                },
                barWidth: "60%",
                label: {
                  show: true,
                  position: "top",
                  fontSize: 16,
                  fontWeight: "bold",
                },
              },
            ],
          },
          isShow: true,
        },
        {
          id: 4,
          type: "bar",
          title: "汇报数量排名",
          echartsOptions: {
            grid: {
              top: 28,
            },
            xAxis: {
              type: "category",
              data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
              axisLabel: {
                interval: 0,
                rotate: 40,
                fontSize: 10,
                color: "#999",
                formatter: (val) => {
                  return val.slice(0, 8);
                },
              },
            },
            yAxis: {
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  type: "dashed",
                },
              },
            },
            series: [
              {
                data: [120, 200, 150, 80, 70, 110, 130],
                type: "bar",
                itemStyle: {
                  color: "#ffba19",
                },
                barWidth: "60%",
                label: {
                  show: true,
                  // formatter: '{c}%',
                  position: "top",
                  fontSize: 16,
                  fontWeight: "bold",
                },
              },
            ],
          },
          isShow: true,
        },
        {
          id: 5,
          type: "bar",
          title: "汇报人数排名",
          echartsOptions: {
            grid: {
              top: 28,
            },
            xAxis: {
              type: "category",
              data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
              axisLabel: {
                interval: 0,
                rotate: 40,
                fontSize: 10,
                color: "#999",
                formatter: (val) => {
                  return val.slice(0, 8);
                },
              },
            },
            yAxis: {
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  type: "dashed",
                },
              },
            },
            series: [
              {
                data: [120, 200, 150, 80, 70, 110, 130],
                type: "bar",
                itemStyle: {
                  color: "#9754e7",
                },
                barWidth: "60%",
                label: {
                  show: true,
                  position: "top",
                  fontSize: 16,
                  fontWeight: "bold",
                },
                markLine: {
                  lineStyle: {
                    type: "dashed",
                  },
                },
              },
            ],
          },
          options: {},
          isShow: true,
        },
      ],
      selectedCompany: [],
    };
  },
  methods: {
    handleBack() {
      window.location.href = "jsToOc://back";
    },
    handleAfterSubmitedBlock() {
      if (this.dailyOverview?.shouldSubmitTotalNum > 0) {
        const width = (this.dailyOverview.supplementTotalNum * 100) / this.dailyOverview.shouldSubmitTotalNum + "%";
        return { width: width };
      } else {
        return { width: "0%" };
      }
    },
    handleSubmitedBlock() {
      if (this.dailyOverview?.shouldSubmitTotalNum > 0) {
        const width = ((this.dailyOverview.submittedTotalNum - this.dailyOverview.supplementTotalNum) * 100) / this.dailyOverview.shouldSubmitTotalNum + "%";
        return { width: width };
      } else {
        return { width: "0%" };
      }
    },

    getDate(format = "yyyy-MM-dd", type) {
      let date = null;
      type = type || "today";
      let now = +Date.now();
      let oneDay = 1000 * 60 * 60 * 24;
      let yesterday = now - oneDay;
      const typeDes = ["yesterday", "today"];
      if (typeDes.includes(type)) {
        date = type === "yesterday" ? new Date(yesterday) : new Date();
      } else {
        date = new Date(type);
      }
      if (date.toString() === "Invalid Date") {
        return;
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    toMore(id) {
      if (this.activeTab === 0) {
        const targetRouteList = ["/daily-overview", "", "/daily-trend", "/daily-rate", "/daily-rate"];
        const targetRoute = targetRouteList[id];
        let params = {
          type: this.seletionDailyData.dateType,
          date:
            this.seletionDailyData.dateType == "天"
              ? dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM-DD")
              : dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM"),
          seletionData: JSON.stringify(this.selectedCompany),
        }
        if(id == 3) {
          params = {
            ...params,
            orderType: 'desc',
            orderField: 'submittedNum',
          }
        }
        if(id == 4) {
          params = {
            ...params,
            orderType: 'desc',
            orderField: 'submitRateDouble',
          }
        }
        console.log(params);
        this.$router.push({
          path: targetRoute,
          query: {
            ...params
          },
        });
      } else if (this.activeTab === 1) {
        const targetRouteList = ["report-overview", "report-flow-list", "report-trend-manage", "user-count-list", "report-manage-submit", "report-manage-submit"];
        const targetRoute = targetRouteList[id];
        let params = {
          personNum: this.overview.personNum,
          approvalNum: this.overview.approvalNum,
          id,
          seletionData: JSON.stringify(this.selectedCompany),
          selectionDate: this.seletionData.selectedDate,
        };
        this.$router.push({
          path: targetRoute,
          query: params,
        });
      }
    },
    tabClickHandle(idx) {
      this.activeTab = idx;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else {
        return `${val}日`;
      }
      // return val;
    },
    selectCompanyHandler() {
      this.$router.push({
        path: "select-data-range",
        query: {
          seletionData: JSON.stringify(this.selectedCompany),
        },
      });
    },
    selectDailyDateHandler() {
      this.showDailyDatePicker = true;
    },
    selectDateHandler() {
      this.showDatePicker = true;
    },
    selectDateTypeHandler() {
      this.showDateType = true;
    },
    dateConfirm(date) {
      this.showDatePicker = false;
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (`${y}-${m}` === this.seletionData.selectedDate) {
        return;
      }
      this.seletionData.selectedDate = `${y}-${m < 10 ? "0" + m : m}`;
      this.getReportCharsData("organization");
    },
    dateDailyConfirm(date) {
      this.showDailyDatePicker = false;
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (`${y}-${m}` === this.seletionDailyData.selectedDate) {
        return;
      }
      this.seletionDailyData.selectedDate = this.seletionDailyData.dateType == "天" ? `${y}-${m < 10 ? "0" + m : m}-${d}` : `${y}-${m < 10 ? "0" + m : m}`;
      this.getDailyChartsData();
    },
    onSelectHandler() {
      this.showDateType = false;
    },

    onDateTypeConfirm(val) {
      this.seletionDailyData.dateType = val;
      this.showDateType = false;
      if (this.seletionDailyData.dateType == "天") {
        // this.seletionDailyData.selectedDate = dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM-DD");
        this.seletionDailyData.selectedDate = this.getDate("yyyy-MM-dd", "yesterday")
      } else {
        this.seletionDailyData.selectedDate = dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM");
      }
      this.getDailyChartsData();
    },
    to (promise, errorProps = {}, errorFirst = true) {
      return promise
        .then((data) => (errorFirst ? [null, data] : [data, null]))
        .catch((err) => {
          if (errorProps) Object.assign(err, errorProps);
          return errorFirst ? [err, null] : [null, err];
        });
    },
    initEcharts() {
      this.boardList.forEach((info, index) => {
        var chartDom = document.getElementById(`canvas-card-${index}`);
        var myChart = chartDom && echarts.init(chartDom);
        info.echartsOptions && myChart && myChart.setOption(info.echartsOptions);
      });
    },
    async getReportCharsData (type) {
      let reqQueue = []
      let params = {
        scopeType: this.companyInfo.scopeType,
        companyId: this.companyInfo.companyId,
        officeId: this.companyInfo.officeId,
        date: this.seletionData.selectedDate,
        currentPageSize: 6,
      };
      let apiList =
        type === "organization"
          ? [getPersonalReportBoard, getPersonaldistribution, getApproveTrend, getPersonalReport, getOrganizationReport, getCompanyPersonReport]
          : [getPersonalReportBoard, getPersonaldistribution, getApproveTrend, getPersonalReport];

      apiList.forEach((req, index) => {
        reqQueue.push(
          new Promise((resolve, reject) => {
            req(params)
              .then((data) => {
                resolve(data);
              })
              .catch((e) => {
                reject(e);
              });
          })
        );
      });
      let res = await Promise.all(reqQueue).catch((err) => Toast.fail(err));
      if (res && Array.isArray(res)) {
        let statistics = res[0];
        if (statistics) {
          let statisticsData = this.returnRes(statistics) || {};
          this.overview = { ...statisticsData };
        }
        let distribution = res[1];
        if (distribution) {
          let filteredRes = []
          let distributionData = this.returnRes(distribution) || [];
          const len = distributionData.length
          const LIMIT_COUNT = 5
          // 长度大于5的部门显示为其他
          if (len > LIMIT_COUNT) {
            distributionData.sort((a, b) => {
              return  b.approvalScale - a.approvalScale 
            })
            let item = {}
            for (var i = 0; i < distributionData.length; i++) {
              if (!i) {
                item = JSON.parse(JSON.stringify(distributionData[i]))
                item.approvalScale = 0
                item.approvalNum = 0
                item.personNum = 0
                item.modelName = "其他"
              }
              if (i < LIMIT_COUNT) {
                filteredRes.push(distributionData[i])
              } else {
                item.approvalScale += +distributionData[i].approvalScale
                item.approvalNum += +distributionData[i].approvalNum
                item.personNum += +distributionData[i].personNum
              }
            }
            filteredRes.push(item)
          } else {
            filteredRes = distributionData
          }
          let { echartsOptions } = this.boardList[1];
          echartsOptions.series[0].data = filteredRes.map(el => ({ 
            value: el.approvalNum, name: el.modelName 
          }))
        }
        let trend = res[2];
        if (trend) {
          let trendData = this.returnRes(trend) || [];
          let { echartsOptions } = this.boardList[2];
          trendData.sort((a, b) => {
            return new Date(a.date).getTime() - new Date(b.date).getTime();
          });
          echartsOptions.xAxis.data = trendData.map((t) => t.date);
          echartsOptions.series[0].data = trendData.map((t) => t.approvalNum);
          echartsOptions.series[1].data = trendData.map((t) => t.personNum);
        }

        let person = res[3];
        if (person) {
          let personData = this.returnRes(person) || [];
          let { echartsOptions } = this.boardList[3];
          echartsOptions.xAxis.data = personData.map((t) => t.staffName);
          echartsOptions.series[0].data = personData.map((t) => t.approvalNum);
        }

        let num = res[4];
        if (num) {
          let numData = this.returnRes(num) || [];
          let { echartsOptions } = this.boardList[4];
          echartsOptions.xAxis.data = numData.map((t) => t.name);
          echartsOptions.series[0].data = numData.map((t) => t.approvalNum);
          echartsOptions.series[0].label.formatter = "{c}";
        }

        let sPerson = res[5];
        if (sPerson) {
          let sPersonData = this.returnRes(sPerson) || [];
          let { echartsOptions } = this.boardList[5];
          echartsOptions.xAxis.data = sPersonData.map((t) => t.name);
          echartsOptions.series[0].data = sPersonData.map((t) => t.personNum);
        }
        this.initEcharts()
      } 
    },
    returnRes(res) {
      res = res || {};
      let { data, code, msg } = res.data || {};
      if (code == 0) {
        return data;
      } else {
        Toast.fail(msg);
        return null;
      }
    },
    async getDailyChartsData() {
      let reqQueue = [];
      let apiList = [getOverviewData, getReportStatisticsTrend, getReportStatisticsSubmitNum, getReportStatisticsSubmitRate];
      const dailyParams = {
        companyId: this.companyInfo.companyId,
        officeId: this.companyInfo.officeId,
        // reportYear: dayjs(this.seletionData.selectedDate).format("YYYY"),
        reportMonth: this.seletionDailyData.dateType === "月" ? dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM") : "",
        reportDate: this.seletionDailyData.dateType === "天" ? dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM-DD") : "",
      };
      if(this.companyInfo.scopeType == 0) {
        dailyParams.blocFlag = 'Y'
      }
      apiList.forEach((req) => {
        reqQueue.push(
          new Promise((resolve, reject) => {
            if (req == getReportStatisticsTrend) {
              const params = {
                companyId: dailyParams.companyId,
                officeId: dailyParams.officeId,
                reportYear: this.seletionDailyData.dateType === "月" ? dayjs(this.seletionDailyData.selectedDate).format("YYYY") : "",
                // reportMonth: this.seletionDailyData.dateType === "天" ? dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM") : "",
                reportDate: this.seletionDailyData.dateType === "天" ? dayjs(this.seletionDailyData.selectedDate).format("YYYY-MM-DD") : "",
              };
              if(this.companyInfo.scopeType == 0) {
                params.blocFlag = 'Y'
              }
              req(params)
                .then((data) => {
                  resolve(data);
                })
                .catch((e) => {
                  reject(e);
                });
            } else {
              req(dailyParams)
                .then((data) => {
                  resolve(data);
                })
                .catch((e) => {
                  reject(e);
                });
            }
          })
        );
      });
      let res = await Promise.all(reqQueue).catch((err) => Toast.fail(err));
      if (res && Array.isArray(res)) {
        let overviewData = res[0];
        if (overviewData) {
          let data = this.returnRes(overviewData) || {};
          this.dailyOverview = { ...data };
        }
        let trend = res[1];
        if (trend) {
          let trendData = (this.returnRes(trend) || []).map((t) => {
            return {
              ...t,
              // per: `${ ((t.supplementNum / t.submittedNum) * 100).toFixed(2) }`
            };
          });
          let { echartsOptions } = this.boardList[2];
          echartsOptions.xAxis.data = trendData.map((t) => {
            if (t.reportMonth) {
              return t.reportMonth
            }
            if (t.reportDate) {
              return t.reportDate
            }
          });
          echartsOptions.xAxis.data.sort((a, b) => {
            return new Date(a).getTime() - new Date(b).getTime();
          });
          echartsOptions.xAxis.data = echartsOptions.xAxis.data.map(item => {
            if(item.length > 7) {
              return item.slice(5)
            }else {
              return item
            }
          })
          echartsOptions.series[0].data = trendData.map((t) => t.submittedNum).reverse();
          echartsOptions.series[1].data = trendData.map((t) => Number(t?.submitRate.replace("%", ""))).reverse();
        }
        let person = res[2];
        if (person) {
          let personData = this.returnRes(person) || [];
          let { echartsOptions } = this.boardList[3];
          echartsOptions.xAxis.data = personData.map((t) => t.companyName || t.officeName);
          echartsOptions.series[0].data = personData.map((t) => t.submittedNum);
        }
        let num = res[3];
        if (num) {
          let numData = this.returnRes(num) || [];
          let { echartsOptions } = this.boardList[4];
          echartsOptions.xAxis.data = numData.map((t) => t.companyName || t.officeName);
          echartsOptions.series[0].data = numData.map((t) => Number(t?.submitRate.replace("%", "")));
          echartsOptions.series[0].label.formatter = "{c}%";
          // echartsOptions.yAxis.max = 100;
        }
        this.initEcharts();
      }
    },
    // getOverviewData() {
    //   const params = {
    //     companyId: this.companyId,
    //     reportMonth: "2022-11",
    //   };
    //   getOverviewData(params).then((res) => {
    //     if (res.data.code === 0) {
    //       // console.log(res.data.data);
    //     }
    //   });
    // },
    async getGroupCompanyInfo() {
      const params = {
        companyId: this.companyId,
      };
      await getCompanySystem(params).then((res) => {
        if (res.data.code === 0) {
          this.companyInfo.companyId = res.data.data[0].id;
          this.seletionData.company = res.data.data[0].name;
          this.selectedCompany = [{ id: res.data.data[0].id, level: 0, name: res.data.data[0].name, type: 0 }];
        }
      });
    },
    getYesterday() {
      let day = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      this.selectedDailyDate = day;
    },  
    scrollHandle (e) {
      let chartList = document.querySelector('.chart-list')
      this.scrollTop = chartList && chartList.scrollTop
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/select-data-range") {
      let params = from.params?.selectedData || [];
      next((vm) => {
        if (params.length) {
          vm.selectedCompany = params;
          let selected = params[params.length - 1];
          vm.seletionData.company = selected.name;
          vm.companyInfo.scopeType = selected.type;
          if (selected.type == 0 || selected.type == 1) {
            vm.companyInfo.companyId = selected.id;
            vm.companyInfo.officeId = "";
            vm.$set(vm.boardList[3], "isShow", true);
            vm.$set(vm.boardList[4], "isShow", true);
            vm.$set(vm.boardList[5], "isShow", true);
          } else if (selected.type == 2) {
            vm.companyInfo.companyId = "";
            vm.companyInfo.officeId = selected.id;
            vm.$set(vm.boardList[3], "isShow", false);
            vm.$set(vm.boardList[4], "isShow", false);
            vm.$set(vm.boardList[5], "isShow", false);
          }
          if (vm.activeTab === 1) {
            vm.getReportCharsData("organization");
          } else {
            vm.$set(vm.boardList[5], "isShow", false);
            vm.getDailyChartsData();
          }
        }
      });
    } else {
      next();
    }
  },
  async mounted() {
    const user = (await VeiBanBridge.getUserInfo()) || {};
    this.companyId = user?.companyId;
    this.getYesterday();
    // this.seletionData.company = this.seletionData.company ? this.seletionData.company : user?.companyName;
    // this.selectedCompany = [{id:user?.companyId}]
    window.addEventListener('scroll', this.scrollHandle , true) 
    this.initEcharts();
    await this.getGroupCompanyInfo();
    await this.getDailyChartsData();
  },
  activated () {
    let chartList = document.querySelector('.chart-list')
    chartList && (chartList.scrollTop = this.scrollTop)
  },
  watch: {
    activeTab: {
      handler(active) {
        if (active === 0) {
          this.boardList[1].isShow = false;
          this.boardList[3].title = "提交人次分布";
          this.boardList[4].title = "提交率排名";
          this.boardList[2].echartsOptions.series[0].name = "提交人次";
          this.boardList[2].echartsOptions.series[1].name = "提交率";
          this.boardList[2].echartsOptions.series[1].label.formatter = "{c}%";
          this.boardList[2].echartsOptions.yAxis = [
              {
                  type: 'value',
                  position: 'left',
                  alignTicks: true,
                  axisLabel: {
                    show: false
                  },
                  axisLine: {
                    lineStyle: {
                      type: "dashed",
                    },
                  }
               },    
              {
                type: 'value',
                position: 'right',
                alignTicks: true,
                min: 0,
                max: 100,
                axisLabel: {
                  show: false,
                },
                axisLine: {
                  lineStyle: {
                    type: "dashed",
                  },
                }
              }
          ]
          this.boardList[2].echartsOptions.series[0].yAxisIndex = 0
          this.boardList[2].echartsOptions.series[1].yAxisIndex = 1
          this.boardList[this.boardList.length - 1].isShow = false;
          this.getDailyChartsData();
        } else if (active === 1) {
          this.boardList[1].isShow = true;
          this.boardList[3].title = "个人汇报排名";
          this.boardList[4].title = "汇报数量排名";
          this.boardList[2].echartsOptions.series[0].name = "汇报数量";
          this.boardList[2].echartsOptions.series[1].name = "提交人数";
          this.boardList[2].echartsOptions.series[1].label.formatter = "{c}";
          this.boardList[2].echartsOptions.yAxis = {
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  type: "dashed",
                },
              }
          }
          delete this.boardList[2].echartsOptions.series[0].yAxisIndex 
          delete this.boardList[2].echartsOptions.series[1].yAxisIndex 
          this.boardList[this.boardList.length - 1].isShow = true;
          this.getReportCharsData("organization");
        }
        this.$nextTick(() => {
          this.initEcharts();
        });
      },
      immediate: true,
    },
  },
  computed: {
    yellowBlockWidth() {
      let width;
      if (this.overview.approvalNum == 0) {
        width = 0;
      } else {
        width = `${((80 * this.overview.personNum) / this.overview.approvalNum).toFixed(2)}%`;
      }
      return width;
    },
    ...mapState(["initialData"]),
  },
  destroyed () {
    window.removeEventListener("scroll", this.scrollHandle)
  }
 }
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.van-action-sheet__item,
.van-action-sheet__cancel {
  padding: 14px 16px;
}
.board-container {
  font-family: PingFang SC;
  color: #333333;
  font-size: 14px;
}
.board-container .board-container-header{
  position: fixed;
  width: 100%;
  background-color: #fff;
  z-index: 10000000000;  
}

.header-title,
.company-selection {
  text-align: center;
  position: relative;
  height: 44px;
  background-color: #fff;
  line-height: 44px;
}
.icon-back {
  font-size: 20px;
  color: #333333;
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
}
.header-title h4 {
  font-weight: 600;
  color: #333333;
  font-size: 18px;
  line-height: 44px;
}
.company-arrow {
  font-size: 18px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.tab-area {
  padding: 10px 16px;
}
.tab-list {
  display: flex;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #1584ff;
}

.tab-item {
  padding: 12px 0;
  font-size: 13px;
  color: #1584ff;
  text-align: center;
}
.active-tab {
  background-color: #1584ff;
  color: #fff;
}

.date-selection-warpper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
}
.date-selection {
  display: flex;
}
.flex-warpper {
  display: flex;
  align-items: center;
  height: 26px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 8px;
}

.flex-warpper:nth-child(1) {
  margin-right: 10px;
}

.date-selection span {
  color: #666;
  margin-right: 5px;
}

.date-show {
  font-family: Source Han Sans CN;
  color: #999999;
  font-size: 12px;
  line-height: 12px;
  color: #999;
  font-size: 12px;
}

.vei-bas {
  vertical-align: baseline;
}
.vei-mid {
  vertical-align: middle;
}

.board-list-cards {
  padding: 16px;
}

.board-cards-item {
  background-color: #fff;
  margin-bottom: 16px;
  /* height: 70vh; */
}

.card-title-warpper {
  display: flex;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-weight: 700;
  font-size: 16px;
}

.card-detail {
  color: #666666;
  font-size: 12px;
}
.canvas-card {
  height: 50vh;
}

.total-statistics {
  display: flex;
  color: #666666;
  font-size: 12px;
  padding: 16px;
  justify-content: space-between;
}

.after-submit {
  padding: 0 16px 16px;
  font-size: 12px;
  color: #666;
}

.background-block {
  display: flex;
  width: 90%;
  height: 30px;
  background-color: #f0f0f0;
  /* border-radius: 0.4rem; */
  position: relative;
  font-weight: 700;
  color: #fff;
  font-size: 12px;
}

.submited-block {
  /* position: absolute;
  left: 0; */
  /* width: 70%; */
  height: 30px;
  /* border-radius: 0.4rem; */
  background-color: #1584ff;
  text-align: right;
  text-indent: 10px;
  line-height: 30px;
  box-sizing: border-box;
  /* padding-right: 14px; */
}

.after-submited-block {
  /* position: absolute;
  left: 0; */
  /* width: 20%; */
  height: 30px;
  /* border-radius: 0.4rem; */
  background-color: #ffba19;
  text-align: right;
  text-indent: 10px;
  line-height: 30px;
  box-sizing: border-box;
  /* padding-right: 14px; */
  z-index: 99;
}

.background-block-warpper {
  display: flex;
  /* justify-content: center; */
  padding: 0 16px;
}
.strip-block {
  height: 30px;
  font-weight: 700;
  color: #666;
  font-size: 12px;
  text-align: right;
  text-indent: 10px;
  line-height: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.yellow-block {
  background-color: #ffba19;
  width: 80%;
}

.blue-block {
  background-color: #1e89ff;
  width: 80%;
}
.num-block {
  width: 20%;
  text-align: right;
}

.strip-block-warpper {
  padding: 0 16px;
}

.tip-block {
  display: inline-block;
  width: 20px;
  height: 10px;
  margin-right: 5px;
}
.chart-list {
  height: 100vh;
  padding-top: 197px;
  /* overflow: scroll; */
}

.bgc-b {
  background-color: #1e89ff;
}
.bgc-c {
  background-color: #f0f0f0;
}
.bgc-o {
  background-color: #ffba19;
}
</style>
